import { useTranslations } from 'next-intl';
import { ReactNode } from 'react';

import { HorizontalDivider } from '@/components/HorizontalDivider';
import {
  AsideContainer,
  MainContainer,
} from '@/components/page-with-aside-layout';
import PrimaryHeading from '@/components/typography/PrimaryHeading';

import LocationSidebar from '../../_components/LocationSidebar';

export type ContactUsLayoutProps = {
  children: ReactNode;
};

export function ContactUsLayout({ children }: ContactUsLayoutProps) {
  const t = useTranslations('contact-us');
  return (
    <>
      <MainContainer>
        <PrimaryHeading className="max-md:text-[28px] mb-5">
          {t('title')}
        </PrimaryHeading>
        <p>{t('description')}</p>
        <HorizontalDivider className="my-5 lg:my-10" />
        {children}
      </MainContainer>
      <AsideContainer>
        <LocationSidebar />
      </AsideContainer>
    </>
  );
}
